package floris.graphics.backoffice.pages.admin.categories.manage

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import floris.graphics.backoffice.components.layouts.PageLayout
import floris.graphics.backoffice.components.sections.DetailsSection
import floris.graphics.core.constants.Res
import com.materialdesignsystem.components.widgets.DangerFilledButton
import com.materialdesignsystem.components.widgets.DsBorderRadius
import com.materialdesignsystem.components.widgets.DsEditableField
import com.materialdesignsystem.components.widgets.DsReadOnlyField
import com.materialdesignsystem.components.widgets.FilledButton
import com.materialdesignsystem.components.widgets.TextButton
import com.materialdesignsystem.constants.Identifiers
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Page("/admin/categories/manage")
@Composable
fun ManageCategoryPage() {

    val context = rememberPageContext()
    val categoryId = remember(context.route) {
        context.route.params["id"]
    }

    val viewModel = remember(categoryId) { ManageCategoryViewModel(categoryId) }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.eventFlow.collect {
            when (it) {
                ManageCategoryUiEvent.NavigateBack -> {
                    // TODO [TicketNumber]: Route is still in the history stack, so we need to remove it...
                    window.history.back()
                }

                ManageCategoryUiEvent.ShowError -> window.alert("Error occurred while saving the category.")
            }
        }
    }

    ManageCategoryPageContent(
        state = state,
        onEvent = viewModel::onEvent
    )
}

@Composable
fun ManageCategoryPageContent(
    state: ManageCategoryState,
    onEvent: (ManageCategoryEvent) -> Unit
) {
    val breakpoint = rememberBreakpoint()

    PageLayout(if (state.isCreationFlow) "Categorie aanmaken" else "Categorie bewerken") {
        Column(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint > Breakpoint.LG) 60.percent else 90.percent)
                .fillMaxHeight()
                .maxWidth(800.px)
                .padding(topBottom = 58.px),
            verticalArrangement = Arrangement.spacedBy(24.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            DsEditableField(
                modifier = Modifier.fillMaxWidth(),
                id = Identifiers.ManageContributors.Name,
                label = Res.String.Name,
                placeholder = Res.String.EnterName,
                value = state.name,
                onValueChange = { onEvent(ManageCategoryEvent.UpdateName(it)) }
            )

            if (state.originalCategory.id.isNotBlank()) {
                DetailsSection(
                    modifier = Modifier.fillMaxWidth(),
                    title = Res.String.Metadata
                ) {
                    Column(Modifier.fillMaxWidth(), Arrangement.spacedBy(16.px)) {
                        DsReadOnlyField(
                            modifier = Modifier.fillMaxWidth(),
                            label = Res.String.ID,
                            value = state.originalCategory.id
                        )

                        DsReadOnlyField(
                            modifier = Modifier.fillMaxWidth(),
                            label = Res.String.CreatedAt,
                            value = state.originalCategory.createdAt
                        )

                        DsReadOnlyField(
                            modifier = Modifier.fillMaxWidth(),
                            label = Res.String.UpdatedAt,
                            value = state.originalCategory.updatedAt
                        )

                        DangerFilledButton(
                            onClick = { onEvent(ManageCategoryEvent.Delete) }
                        ) {
                            Text(Res.String.Delete)
                        }
                    }
                }
            }

            Row(horizontalArrangement = Arrangement.spacedBy(16.px)) {
                FilledButton(
                    enabled = state.hasChanged,
                    onClick = { onEvent(ManageCategoryEvent.Save) }
                ) {
                    Text(Res.String.Save)
                }
                TextButton(
                    borderRadius = DsBorderRadius(8.px),
                    onClick = { onEvent(ManageCategoryEvent.Cancel) }
                ) {
                    Text(Res.String.Cancel)
                }
            }
        }
    }
}
